import type { BraceletPatternDto, CellValue } from '@miyuki/types';

import {
  assertColorIndex,
  assertColumnIndex,
  assertRowIndex,
  withCell,
  NO_CHANGES,
  type PatternEdit,
} from './pattern.entity';

/**
 * Cambia una única celda. Si el valor ya es el que se pide, devuelve el mismo
 * patrón y un parche vacío: repasar una zona con el color que ya tenía no debe
 * llenar el historial de pasos que no hacen nada.
 */
function setCell(
  pattern: BraceletPatternDto,
  row: number,
  column: number,
  value: CellValue,
): PatternEdit {
  assertRowIndex(pattern, row);
  assertColumnIndex(pattern, column);

  const previous = pattern.rows[row]?.[column] ?? null;
  if (previous === value) {
    return { pattern, undo: NO_CHANGES };
  }

  return {
    pattern: withCell(pattern, row, column, value),
    undo: { kind: 'cells', cells: [{ row, column, value: previous }] },
  };
}

/** Coloca una mostacilla del color indicado, llene o no la celda. */
export function paintCell(
  pattern: BraceletPatternDto,
  row: number,
  column: number,
  colorIndex: number,
): PatternEdit {
  assertColorIndex(pattern, colorIndex);
  return setCell(pattern, row, column, colorIndex);
}

/** Deja la celda sin mostacilla. */
export function clearCell(pattern: BraceletPatternDto, row: number, column: number): PatternEdit {
  return setCell(pattern, row, column, null);
}
